import React, { Component } from "react";
//import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import $ from "jquery";
import Header from "./components/Header";
import Home from "./components/Home";
import About from "./components/About";
import Skills from "./components/Skills";
import Experience from "./components/Experience";
import Projects from "./components/Projects";
import Footer from "./components/Footer";
import Contact from "./components/ContactForm";
var resumePath =
  document.documentElement.lang === window.$primaryLanguage
    ? `res_secondaryLanguage.json`
    : `res_primaryLanguage.json`;
class App extends Component {
  constructor(props) {
    super();
    this.state = {
      foo: "bar",
      resumeData: {},
      sharedData: {},
    };
  }

  componentDidMount = () => {
    this.loadSharedData();
    this.loadResumeFromPath(resumePath);
  };

  loadResumeFromPath = (path) => {
    $.ajax({
      url: path,
      dataType: "json",
      cache: false,
      success: function (data) {
        this.setState({ resumeData: data });
      }.bind(this),
      error: function (xhr, status, err) {
        alert(err);
      },
    });
  };

  loadSharedData = () => {
    $.ajax({
      url: `portfolio_shared_data.json`,
      dataType: "json",
      cache: false,
      success: function (data) {
        this.setState(
          { sharedData: data },
          () => (document.title = `${this.state.sharedData.basic_info.name}`)
        );
      }.bind(this),
      error: function (xhr, status, err) {
        alert(err);
      },
    });
  };

  render() {
    return (
      <div>
        <Header />
        <Home sharedBasicInfo={this.state.sharedData.basic_info} />
        <About
          resumeBasicInfo={this.state.resumeData.basic_info}
          sharedBasicInfo={this.state.sharedData.basic_info}
        />
        <Skills />
        <Experience
          resumeExperience={this.state.resumeData.experience}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Projects
          resumeProjects={this.state.resumeData.projects}
          resumeBasicInfo={this.state.resumeData.basic_info}
        />
        <Contact />
        <Footer />
      </div>
    );
  }
}

export default App;
